/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_Dell_GroupInputs */

const en_colleague_action_dell_group = /** @type {(inputs: Colleague_Action_Dell_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dell tools`)
};

const ja_colleague_action_dell_group = /** @type {(inputs: Colleague_Action_Dell_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dell ツール`)
};

const fr_colleague_action_dell_group = /** @type {(inputs: Colleague_Action_Dell_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils Dell`)
};

const de_colleague_action_dell_group = /** @type {(inputs: Colleague_Action_Dell_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dell-Tools`)
};

/**
* | output |
* | --- |
* | "Dell tools" |
*
* @param {Colleague_Action_Dell_GroupInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_dell_group = /** @type {((inputs?: Colleague_Action_Dell_GroupInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_Dell_GroupInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_dell_group(inputs)
	if (locale === "ja") return ja_colleague_action_dell_group(inputs)
	if (locale === "fr") return fr_colleague_action_dell_group(inputs)
	return de_colleague_action_dell_group(inputs)
});